import React from 'react';
import Icon from './Icon';
import { useCampaignRules, deniedReason } from './CampaignRulesContext';

/**
 * Prototype `.btn`. `variant`: default | primary | ghost | dashed | danger.
 * `small` and `iconOnly` are size modifiers; `icon` names a leading icon.
 * Icon-only buttons need `aria-label`.
 * `need` names a Rules & Permissions action (e.g. "candidate.add"); inside a
 * CampaignRulesProvider the button is disabled with the reason when it isn't allowed.
 */
const Button = React.forwardRef(function Button(
  { variant = 'default', small = false, iconOnly = false, icon, iconAfter, children, className = '', type = 'button', need, ...rest },
  ref,
) {
  const cls = ['wz-btn'];
  if (variant !== 'default') cls.push(variant);
  if (small) cls.push('small');
  if (iconOnly) cls.push('icon');
  if (className) cls.push(className);
  const rules = useCampaignRules();
  if (need && rules && !rules.can(need)) {
    rest = { ...rest, disabled: true, title: deniedReason(rules), onClick: undefined };
  }
  return (
    <button ref={ref} type={type} className={cls.join(' ')} {...rest}>
      {icon && <Icon name={icon} />}
      {children}
      {iconAfter && <Icon name={iconAfter} />}
    </button>
  );
});

export default Button;
